var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_79_452)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99977 9.99973C14.1051 10.0368 19.7549 11.0558 23.5549 12.8713C27.1543 14.5911 29.121 17.031 29.9998 20.2578V51.2996C25.4518 47.9413 18.4621 46.0036 6.03719 45.9997C6.02014 45.9555 5.99977 45.8779 5.99977 45.7585V9.99973ZM33.9998 51.2967C38.5563 47.9265 45.5431 45.9997 57.9998 45.9997V9.99971C49.8944 10.0368 44.2447 11.0558 40.4446 12.8713C36.8452 14.5911 34.8785 17.031 33.9998 20.2578V51.2967ZM31.9998 14.9632C30.4816 12.596 28.2628 10.6876 25.2793 9.26213C20.6923 7.07057 14.3448 6.03711 6.00874 5.99973L6.00731 5.99972C5.48048 5.99774 4.95846 6.10004 4.47135 6.30073C3.98424 6.50142 3.54166 6.79654 3.16913 7.16907C2.7966 7.5416 2.50149 7.98418 2.30079 8.47129C2.10066 8.95704 1.99837 9.47751 1.99977 10.0028V45.7585C1.99977 46.7768 2.31522 47.8182 3.01384 48.6388C3.73768 49.4889 4.79338 49.9997 5.99977 49.9997C21.7618 49.9997 27.2034 53.2018 30.4374 57.2483C30.8169 57.7231 31.3916 57.9996 31.9993 57.9997C32.6071 57.9998 33.1819 57.7236 33.5615 57.2491C36.8177 53.1786 42.2367 49.9997 57.9998 49.9997C59.0606 49.9997 60.078 49.5783 60.8282 48.8281C61.5784 48.078 61.9998 47.0606 61.9998 45.9997V10.0024C62.0011 9.47723 61.8988 8.95691 61.6987 8.47129C61.4981 7.98418 61.2029 7.5416 60.8304 7.16907C60.4579 6.79654 60.0153 6.50142 59.5282 6.30073C59.0411 6.10004 58.5191 5.99774 57.9922 5.99972L57.9908 5.99973C49.6547 6.03711 43.3072 7.07057 38.7202 9.26213C35.7368 10.6876 33.5179 12.596 31.9998 14.9632Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_79_452",
    x: -0.745136,
    y: -0.248379,
    width: 65.4903,
    height: 66.3199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_79_452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_79_452",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_79_452"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_79_452",
    result: "effect3_innerShadow_79_452"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.7c8a340025658904d480e82c7e0c25f6.svg";
export { ForwardRef as ReactComponent };